module.exports = __webpack_public_path__ + "media/bootstrap-icons/person-plus-fill-57f5c296.svg";